<script setup>
  import { DialogPanel, DialogTitle } from '@headlessui/vue'
  import { Form } from 'vee-validate'
  import * as yup from 'yup'
  import coverLetterSchema from '~/utils/schema/cover-letter-schema'

  const props = defineProps({
    close: { type: Function, required: true },
    onSubmit: { type: Function, required: true },
    mandatoryLetter: { type: Boolean },
    canLetterQuestions: { type: Boolean },
    motivationLetterField: { type: Boolean },
    messageField: { type: Boolean },
    otherFileField: { type: Boolean },
    job: { type: Object }
  })

  const coverLetter = ref(false)
  const messageInput = ref(false)

  const schema = yup
    .object({
      cv: yupFile({ types: ['application/pdf'] })
        .required('${label} requis')
        .label('CV'),
      otherFile: yupFile({ types: ['application/pdf'] }).label('Autre pièce jointe'),
      message: yup.string().label('Message')
    })
    .concat(coverLetterSchema(props.mandatoryLetter, props.canLetterQuestions))

  const onSubmit = async (values, actions) => {
    values = schema.cast(values, { stripUnknown: true })
    if (props.motivationLetterField && !values.letter && coverLetter.value.canGenerateLetter()) {
      const pdf = await coverLetter.value.getGeneratedLetterPdf()
      values.letter = pdf
    }
    props.onSubmit(values)
  }
</script>

<template>
  <DialogPanel class="my-auto w-full max-w-lg rounded-xl bg-white p-4 shadow">
    <DialogTitle class="text-center font-special text-3xl font-bold">Je postule</DialogTitle>
    <Form class="mt-4" v-slot="{ values, errors, isSubmitting }" :validationSchema="schema" @submit="onSubmit">
      <div class="-m-2 flex flex-wrap">
        <FormField
          class="basis-full p-2"
          id="cv"
          accept="application/pdf"
          :error="errors.cv"
          label="CV (format PDF)"
          name="cv"
          required
          type="file"
        />
        <div class="basis-full p-2" v-if="motivationLetterField">
          <FormCoverLetter ref="coverLetter" :job="job" :errors="errors" :values="values" :required="props.mandatoryLetter" />
        </div>
        <div class="basis-full p-2" v-if="messageField">
          <p class="cursor-pointer" @click="messageInput = messageInput ? false : true">> Envie d'envoyer un petit mot aux recruteurs ?</p>
          <FormField class="basis-full pt-2" id="message" v-if="messageInput" :error="errors.message" name="message" required type="textarea" />
        </div>
        <FormField
          class="basis-full p-2"
          id="otherFile"
          v-if="otherFileField"
          :error="errors.otherFile"
          label="Autre pièce jointe (lettre de recommandation, portfolio...)"
          name="otherFile"
          type="file"
        />
      </div>
      <div class="mt-4 space-x-2 text-center">
        <Button color="secondary" outline type="reset" @click="close">Annuler</Button>
        <Button :disabled="isSubmitting" type="submit">Postuler</Button>
      </div>
    </Form>
  </DialogPanel>
</template>
